import { Phone, Mail } from "lucide-react";
import { PHONE, PHONE_HREF, EMAIL } from "../../data/site";
import { Reveal, SectionLabel } from "./Reveal";
import { ContactForm } from "./ContactForm";

const ContactLink = ({ href, icon: Icon, label, value, testId }) => (
  <a href={href} data-testid={testId} className="trust-card group flex items-center gap-5 border border-white/10 p-6">
    <div className="grid h-14 w-14 shrink-0 place-items-center bg-[#1E9BFF] text-black transition-transform duration-300 group-hover:scale-105"><Icon className="h-6 w-6" /></div>
    <div className="min-w-0">
      <div className="font-mono text-xs uppercase tracking-widest text-neutral-500">{label}</div>
      <div className="mt-1 break-all font-display text-xl font-bold sm:text-2xl">{value}</div>
    </div>
  </a>
);

export const Contact = () => (
  <section id="contact" data-testid="contact-section" className="relative bg-[#050607] py-24 md:py-32">
    <div className="mx-auto grid max-w-7xl gap-14 px-5 lg:grid-cols-12 lg:px-8">
      <Reveal className="lg:col-span-5">
        <SectionLabel index="05">Get in Touch</SectionLabel>
        <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-none sm:text-5xl">Request a<br /><span className="text-glow text-[#1E9BFF]">Free Quote</span></h2>
        <p className="mt-8 text-neutral-400">Tell us what you need and we'll get back to you quickly. For urgent drainage problems, give us a call.</p>
        <div className="mt-10 space-y-4">
          <ContactLink href={PHONE_HREF} icon={Phone} label="Call Us" value={PHONE} testId="contact-phone-link" />
          <ContactLink href={`mailto:${EMAIL}`} icon={Mail} label="Email Us" value={EMAIL} testId="contact-email-link" />
        </div>
      </Reveal>
      <Reveal delay={120} className="lg:col-span-7">
        <ContactForm />
      </Reveal>
    </div>
  </section>
);
